import { alwaysRefetchApiQueryOptions } from 'BreetHelpers';
import { useFundRequestContext } from 'BreetHooks';
import { useGetFeatureNoteQuery } from 'BreetRedux';

import { NotificationBanner } from '../NotificationBanner';
import { SelectWallet } from '../SelectWallet';

const Header = () => {
	const { selectedWallet, selectWallet } = useFundRequestContext();

	const { data: featureNotesData } = useGetFeatureNoteQuery(undefined, alwaysRefetchApiQueryOptions);

	const featureNotes = featureNotesData?.data;

	const noteData = featureNotes?.find(({ feature, type }) => feature === 'wallet' && type === 'notes');

	return (
		<>
			<div className='payment-request-form_notificationbanner hidden'>
				<NotificationBanner
					message={noteData?.message}
					status='warning'
					type='standard'
				/>
			</div>

			<SelectWallet
				title='Which wallet do you want to fund?'
				selectWallet={selectWallet}
				selectedWallet={selectedWallet}
				toolTip={
					"Using crypto, you can fund any of your business wallets. If it's a non-USD wallet, the crypto will be automatically converted using the current rate at the time of the transaction."
				}
			/>
		</>
	);
};

export default Header;
